<template>
  <div>
    <el-dialog
      :title="$t('location.location')"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      width="50%"
      @closed="$emit('handleClosed')"
    >
      <transition name="fade">
        <div class="location-warp" v-if="dialogVisible">
          <component
            v-if="dialogVisible"
            :is="componentMap[mapObj.specId]"
            :mapObj="mapObj"
          />
        </div>
      </transition>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button
          type="primary"
          @click="handleSaveLocation"
          icon="el-icon-check"
          >{{ $t("buttons.determine") }}</el-button
        >
        <el-button icon="el-icon-close" @click="dialogVisible = false">{{
          $t("buttons.cancel")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import OnePoint from './components/OnePoint'
import DoublePoints from './components/DoublePoints'
export default {
  name: 'Location',
  components: { OnePoint, DoublePoints },
  data() {
    return {
      componentMap: {
        101: 'OnePoint',
        102: 'DoublePoints'
      },
      dialogVisible: false,
      mapObj: {
        autoLoc: false,
        manualLoc: false,
        manualName: false,
        limits: false,
        nearBy: {
          center: {
            lng: 116.404, // 经度
            lat: 39.915 // 纬度
          },
          radius: 200
        },
        startPoint: {
          lng: 116.404, // 经度
          lat: 39.915 // 纬度
        },
        endPoint: {},
        startContent: '',
        endContent: ''
      }
    }
  },
  methods: {
    handleOpenLocation(mapObj) {
      this.dialogVisible = true
      this.mapObj = JSON.parse(JSON.stringify(mapObj))
    },
    handleSaveLocation() {
      console.log(this.mapObj)
      this.$emit('handleSaveLocation', this.mapObj)
      this.dialogVisible = false
    }
  }
}
</script>
<style lang="scss">
.location-warp {
  width: 100%;
  height: 400px;
}
</style>